import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { StorageService } from '../../../core/services/storage/storage.service';
import { ICarrierService } from '../../../ship/models/carrier-service.interface';
import { ICustomerCarrier } from '../../models/customer-carrier.interface';

@Injectable()
export class LookupService {
    constructor(private httpClientService: HttpClientService,
                private apiEndpointService: ApiEndpointService,
                private storageService: StorageService,
    ) {
    }

    public getCustomerCarriers(customerId: string): Observable<ICustomerCarrier[]> {
        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCustomerCarriers'))
                                           .param('customerId', customerId)
                                           .toString();

        return this.httpClientService.get<ICustomerCarrier[]>(endpoint);
    }

    public getCarrierServices(carrierCode: string): Observable<ICarrierService> {
        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCarrierServices'))
                                           .param('carrierCode', carrierCode)
                                           .toString();

        return this.httpClientService.get<ICarrierService>(endpoint);
    }

    public getCountries(): Observable<{ CountryCode: string, CountryName: string }[]> {
        // const storageName = 'lookup-countries';
        // const lookupCountries = this.storageService.get<any[]>(storageName);
        // if (lookupCountries) {
        //   return of(lookupCountries);
        // }

        const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getCountries')).toString();
        return this.httpClientService.get<{ CountryCode: string, CountryName: string }[]>(endpoint)
                   .pipe(
                       shareReplay(1),
                       map(
                           (res) => {
                               // const countries = res;
                               // this.storageService.set(storageName, countries);
                               return res;
                           }));
    }

    /**
     * Gets carrier countries.
     *
     * @param {string} carrierCode
     * @param {string} selectionType
     * @returns {Observable<any>}
     */
    public getCarrierCountries(carrierCode: string, selectionType: string): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getCarrierCountries'))
            .query({
                carriercode: carrierCode,
                isEU: false,
                selectiontype: selectionType,
            })
            .toString();
        return this.httpClientService.get<any>(endpoint);
    }
}
